import React from 'react';
import PropTypes from 'prop-types';
import Text from 'components/shared/Text';
import ButtonText from 'components/shared/ButtonText';
import styles from './styles.module.scss';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className={styles.errorBoundary}>
          <Text>Oops! Something went wrong</Text>
          <ButtonText underlined onClick={() => this.setState({ hasError: false })}>
            Reload
          </ButtonText>
        </div>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]).isRequired
};
